import { render, staticRenderFns } from "./InterDiary.vue?vue&type=template&id=24297124&scoped=true"
import script from "./InterDiary.vue?vue&type=script&lang=js"
export * from "./InterDiary.vue?vue&type=script&lang=js"
import style0 from "./InterDiary.vue?vue&type=style&index=0&id=24297124&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24297124",
  null
  
)

export default component.exports